import { IStructFireBase } from './../../interfaces/shared/struct-firebase.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatesTimesService {

  constructor(
  ) { }

  // Fecha actual en string YYYYMMDD
  //   si se quiere convertir a integer usar parseInt(getCurrentDate())
  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2); // Add leading zero if needed
    const day = ('0' + today.getDate()).slice(-2); // Add leading zero if needed
    return `${year}${month}${day}`; // YYYYMMDD
  }

  // Fecha y hora actual en string AAAAMMDD_HHMMss.SSS
  getCurrentDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2); // Add leading zero if needed
    const day = ('0' + now.getDate()).slice(-2); // Add leading zero if needed
    const hours = ('0' + now.getHours()).slice(-2); // Add leading zero if needed
    const minutes = ('0' + now.getMinutes()).slice(-2); // Add leading zero if needed
    const seconds = ('0' + now.getSeconds()).slice(-2); // Add leading zero if needed
    const milliseconds = ('00' + now.getMilliseconds()).slice(-3); // Add leading zeros if needed
    return `${year}${month}${day}_${hours}${minutes}${seconds}.${milliseconds}`; // AAAAMMDD_HHMMss.SSS
  }

  setFormatDatePattern(struct: IStructFireBase, value): string {
    if (struct.inputType === "time" && value?.includes(':')) {
      const formatTime = value.replace(':', '');
      return formatTime;
    }

    if (struct.inputType === "date" && struct.pattern === "YYYYMM" && value?.includes('-')) {
      const fomartDate = value.replace('-', '');
      return fomartDate;
    }

    if (struct.inputType === "date" && struct.pattern === "AAAAMMDD" && value?.includes('-')) {
      const fomartDate = value.split("-").join("");
      return fomartDate;
    }

    if (struct.inputType === "date" && struct.pattern === "DDMMAAAA" && value?.includes('-')) {
      const fomartDate = value.split("-").join("");
      const format = `${fomartDate.slice(-2)}${fomartDate.slice(4, 6)}${fomartDate.slice(0, 4)}`
      return format;
    }

    return value;
  }

  formateDateTime(value: string): string {
    const year = value.slice(0, 4);
    const month = value.slice(4, 6);
    const day = value.slice(6, 8);
    const hour = value.slice(9, 11);
    const minute = value.slice(11, 13);
    return `${year}-${month}-${day}T${hour}:${minute}`;
  }


  setFormateDateTime(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
    return `${year}${month}${day}_${hours}${minutes}${seconds}.${milliseconds}`;
  }

  setFormateDate(date: string, format: string): string {
    const d = new Date(date);
    const yyyy = d.getFullYear().toString();
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    switch (format) {
      case 'DDMMAAAA':
        return `${dd}${mm}${yyyy}`;
      case 'YYYYMM':
        return `${yyyy}${mm}`;
      case 'AAAAMMDD':
        return `${yyyy}${mm}${dd}`;

      default:
        return date;
    }
  }

}
